export enum FeedbackClient {
  AngularWeb = 'angular_web',
  ReactNative = 'react_native',
}
